import styled from "styled-components";

export const FooterWrapper = styled.footer`
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000;
  color: #fff;
  text-align: center;
  font-size: 1rem;
`;
